import React from "react";
import { Button, Modal, Form } from "semantic-ui-react";
import { Field, reduxForm } from "redux-form";
import { translate } from "react-i18next";
const RoomGroupModalComponent = props => (
  <Modal open={props.isOpenModal} onActionClick={props.toggleModal}>
    <Modal.Header>
      {props.selected
        ? props.t("room:editRoomTypeText")
        : props.t("room:addRoomGroupButton")}
    </Modal.Header>
    <Modal.Content>
      <Modal.Description>
        <Form as="form" size="large" onSubmit={props.handleSubmit}>
          <Field
            name="name"
            type="text"
            component={Form.Input}
            fluid
            placeholder={props.t("room:roomTypeNameText")}
          />
          <Button color="blue" type="submit">
            {props.t("common:saveText")}
          </Button>
          <Button onClick={props.toggleModal}>
            {props.t("common:cancelText")}
          </Button>
        </Form>
      </Modal.Description>
    </Modal.Content>
  </Modal>
);

export const RoomGroupModal = reduxForm({
  form: "roomGroups",
  enableReinitialize: true
})(translate("translations")(RoomGroupModalComponent));



// WEBPACK FOOTER //
// ./src/rooms/groups/RoomGroupsList/RoomGroupModal.js